<template>
  <div>
    <div>
      <b-row>
        <b-colxx xxs="12" class="mb-4 pl-0 pr-0">
          <header-drop-down-filter
            leftHeaderText="Participant Focus Dashboard"
            :sites="allSitesList"
            :countries="countryList"
            :callApiCompleted="true"
            :checkedSitesApply="sitesSelected[0] && sitesSelected[0] === 'all' ? allSitesList : sitesSelected"
            :checkedCountriesApply="countrySelected[0] && countrySelected[0] === 'all' ? countryList : countrySelected"
            :exportBtn="true"
            :participantsBtn="true"
            @onApplyCountry="filterCountry"
            @onApplySites="filterSites"

            @onApplyParticipants="filterParticipants"
            @onFetchedParticipants="fetchedParticipants"
            :dataPicker="dataPicker"
            @onApplyRangeMonth="getRangeMonth"

            v-if="studyData"
            :specificSiteId="specificSiteId"
            :zoomGraphValue="zoomGraphValue"
            :toggleFeatures="toggleFeatures"
            :studyData="studyData"
            :toggleFilters="toggleFilters"
          ></header-drop-down-filter>
        </b-colxx>
      </b-row>
      <!-- SECTION 2 -->
      <!-- Overall Data Collection with Completion Metrics   -->
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-data-collection-metrics'" v-if="complianceWidgets">
        <b-colxx class="pl-0 pb-6 pr-0" xl="12" lg="12" md="12" :class="zoomGraphValue === 'overall-data-collection-metrics' ? 'overall-data-collection-metrics-zoom' : ''" style="transition-duration: 0.2s">
          <OverallCollectionMetrics
            :siteListInParticipants="siteListInParticipants"
            :collectionMetricsRaw="completion"
            :participantRaw="completionParticipant"

            :filterTriggered="filterTriggered"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :specificSiteId="specificSiteId"
            :customType="'scrollstackedcolumn2d'"
            :zoomGraphValue="zoomGraphValue"
            :listParticipants="siteListInParticipants"

            :dataLoaded="dataLoaded.overallCollectionMetricRaw"
            v-on:zoomEnabled="zoomGraphValue = 'overall-data-collection-metrics'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            titleChart="Overall Data Collection with Completion Metrics"
          >
          </OverallCollectionMetrics>
        </b-colxx>
      </b-row>
      <!-- Overall Data Collection with Completion Metrics   -->
      <!-- END OF SECTION 2 -->


      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'consent-disposition'">
        <b-colxx :class="zoomGraphValue == 'consent-disposition' ? 'col-xl-12 consent-disposition-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'consent-disposition'" style="transition-duration: 0.2s">
          <eConsentDisposition
            containerId="blank"
            title="Consent Disposition"
            :zoomGraphValue="zoomGraphValue"
            :specificSiteId="specificSiteId"
            :vis="eConsentDispositionData"
            v-on:zoomEnabled="zoomGraphValue = 'consent-disposition'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :studyId="studyId"
            :dataLoaded="dataLoaded.visConsentDisposition"
          ></eConsentDisposition>
        </b-colxx>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OverallCollectionMetrics from "../containers/overall-collection-metrics";
import eConsentDisposition from "../containers/recruitment-fusion-doughnut-card.vue";
import {SET_STUDY_ID, SET_SITE_LIST_IN_PARTICIPANTS, SET_SPECIFIC_SITE_ID} from "../../vuex/modules/participant-focus/mutation-types"
import HeaderDropDownFilter from "../form-components/header-drop-down-filter";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";

export default {
  components: {
    OverallCollectionMetrics,
    eConsentDisposition,
    HeaderDropDownFilter
  },
  props: {
    toggleFeatures: { type: Array, default: () => [] },
    studyData: { type: Object, default: null }
  },
  mounted() {
    const specificSiteId = _get(this.user, "siteIds", []);

    this.$router.push({ query: { automatic_off_loader: false } });
    this.$store.commit(SET_STUDY_ID, this.$route.params.studyId);
    this.$store.commit(SET_SPECIFIC_SITE_ID, specificSiteId);
    
    this.$store.dispatch("loadParticipantFocusDashboard", this.$api)
    .finally(() => {
      this.turnOffGlobalLoader()
      this.dataLoaded["overallCollectionMetricRaw"] = true;
      this.dataLoaded["visConsentDisposition"] = true;
    })
  },
  data(){
    return {
      complianceWidgets: [],
      dataLoaded: {
        overallCollectionMetricRaw: false,
        visConsentDisposition: false
      },
      visConsentDisposition: null,
      zoomGraphValue: "",
      filterTriggered: false,

      participantRaws: [],
      participantList: [],
      participantsSelected: ["all"],
      toggleFilters: {
        sites: true,
        countries: true,
        date: true,
        participant: true
      },

      dataPicker: []
    }
  },
  methods: {
    filterCountry(payload){
      const selectedCountries = payload.isCheckAll === true ?
        this.countryList : [...payload.checked]
      this.$store.dispatch("filterByCountries", {
        selectedCountries,
        filterAll: payload.isCheckAll
      }).finally(() => {
        this.filterTriggered = !this.filterTriggered
      });
    },
    filterSites(payload){
      const selectedSites = payload.isCheckAll === true ?
        this.allSitesList : [...payload.checked]
      this.$store.dispatch("filterBySites", {
        selectedSites,
        detailSite: payload.detailSite,
        filterAll: payload.isCheckAll
      }).finally(() => {
        this.filterTriggered = !this.filterTriggered
      });
    },
    filterParticipants(payload){
      const {checkedParticipants, isCheckAll} = payload
      const selectedParticipants = isCheckAll === true ?
        ["all"] : [...checkedParticipants]

      this.$store.dispatch("filterByParticipants", {$api: this.$api, selectedParticipants})
      .finally(() => {
        this.turnOffGlobalLoader()
        this.filterTriggered = !this.filterTriggered
      });
    },
    fetchedParticipants(payload) {
      this.$store.commit(SET_SITE_LIST_IN_PARTICIPANTS, payload)
    },
    getRangeMonth(payload){
      if(!_isEmpty(payload)){
        const fromDate = payload[0].value;
        const toDate = payload[1].value;
        this.$store.dispatch("filterByDates", {$api: this.$api, fromDate, toDate})
        .finally(() => {
          this.turnOffGlobalLoader()
          this.filterTriggered = !this.filterTriggered
        });
      }
    },
    async turnOffGlobalLoader() {
      const query = Object.assign({}, this.$route.query);
      delete query.automatic_off_loader;
      this.$router.replace({ query });
      this.$store.commit("SHOW_LOADER", false);
    }
  },
  computed: {
    ...mapGetters([
    "studyId",
    "completion",
    "completionParticipant",
    "siteListInParticipants",
    "eConsentRawData",
    "eConsentDispositionData",
    "consentBlocks",
    "countryList",
    "allSitesList",
    "countrySelected",
    "sitesSelected",
    "specificSiteId",
    "user"
    ])
  }
}
</script>